/*
 * TFR Shoes – prévia rápida do produto.
 * O botão "Ver detalhes" dos cards abre uma janela na mesma tela com fotos, preço, opções e o botão
 * do WhatsApp. O conteúdo vem da seção "tfr-quick-view" (Section Rendering API da Shopify).
 * Sem carrinho e sem compra: só abre o WhatsApp com a mensagem pronta para a cliente enviar.
 */
(function () {
  'use strict';
  if (window.__tfrQuickView) return;
  window.__tfrQuickView = true;

  var DEFAULT_BUY = 'Olá! Quero comprar este modelo da TFR Shoes:\nProduto: {produto}\n{opcoes}\nLink: {link}';
  var DEFAULT_UNAVAILABLE = 'Olá! Gostaria de consultar a disponibilidade deste modelo da TFR Shoes:\nProduto: {produto}\n{opcoes}\nLink: {link}';
  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var cache = {};
  var modal, panel, content, lastFocus, scrollY = 0;

  function fmt(cents) { return money.format((cents || 0) / 100); }

  function productUrlFrom(trigger) {
    var a = trigger.closest('a[href*="/products/"]');
    if (!a) {
      var card = trigger.closest('.card-wrapper, .tfr-pc__slide, li, .grid__item');
      a = card && card.querySelector('a[href*="/products/"]');
    }
    return a ? a.getAttribute('href') : null;
  }

  function build() {
    modal = document.createElement('div');
    modal.className = 'tfr-qv';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="tfr-qv__backdrop" data-tfr-qv-close></div>' +
      '<div class="tfr-qv__panel" role="dialog" aria-modal="true" aria-labelledby="TfrQvTitle" tabindex="-1">' +
      '<button type="button" class="tfr-qv__close" data-tfr-qv-close aria-label="Fechar">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button><div class="tfr-qv__content" data-tfr-qv-content></div></div>';
    document.body.appendChild(modal);
    panel = modal.querySelector('.tfr-qv__panel');
    content = modal.querySelector('[data-tfr-qv-content]');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-tfr-qv-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hidden && e.key === 'Escape') close();
    });
  }

  function lockScroll() {
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }
  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, scrollY);
  }

  function open(url) {
    if (!modal) build();
    lastFocus = document.activeElement;
    content.innerHTML = '<div class="tfr-qv__loading" aria-live="polite"><span class="tfr-qv__spinner"></span><span class="visually-hidden">Carregando</span></div>';
    modal.hidden = false;
    lockScroll();
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    setTimeout(function () { modal.classList.add('is-open'); }, 30);
    panel.focus({ preventScroll: true });

    var clean = url.split('?')[0];
    var load = cache[clean]
      ? Promise.resolve(cache[clean])
      : fetch(clean + '?section_id=tfr-quick-view', { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(function (html) { cache[clean] = html; return html; });

    load.then(function (html) {
      if (modal.hidden) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var body = doc.querySelector('[data-tfr-qv-body]');
      if (!body) throw new Error('vazio');
      content.innerHTML = '';
      content.appendChild(document.importNode(body, true));
      init(content.querySelector('[data-tfr-qv-body]'), clean);
    }).catch(function () {
      window.location.href = url;
    });
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.hidden = true;
      content.innerHTML = '';
    }, 220);
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function init(root, url) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-tfr-qv-data]').textContent); } catch (e) { return; }
    var track = root.querySelector('[data-tfr-qv-track]');
    var dots = root.querySelectorAll('.tfr-qv__dot');
    var slides = track ? track.querySelectorAll('.tfr-qv__slide') : [];
    var fieldsets = root.querySelectorAll('[data-tfr-qv-option]');
    var priceEl = root.querySelector('[data-tfr-qv-price]');
    var compareEl = root.querySelector('[data-tfr-qv-compare]');
    var payEl = root.querySelector('[data-tfr-qv-pay]');
    var wa = root.querySelector('[data-tfr-qv-wa]');
    var waLabel = root.querySelector('[data-tfr-qv-wa-label]');
    var hint = root.querySelector('[data-tfr-qv-hint]');
    var helpers = window.TfrWhatsApp || {};
    var selected = data.options.map(function (_, i) {
      var values = Array.from(new Set(data.variants.map(function (v) { return v.options[i]; })));
      return values.length === 1 ? values[0] : null;
    });

    // Galeria: bolinhas acompanham o deslizar.
    function activeSlide() {
      if (!track) return 0;
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    }
    if (track) {
      track.addEventListener('scroll', function () {
        var idx = activeSlide();
        dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }, { passive: true });
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); });
    });
    function goToMedia(id) {
      if (!id || !track) return;
      slides.forEach(function (s, i) {
        if (String(s.dataset.mediaId) === String(id)) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    }

    function matching() {
      if (selected.some(function (v) { return v === null; })) return null;
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      }) || null;
    }

    function pay(price) {
      if (!payEl) return;
      if (!price) { payEl.innerHTML = ''; return; }
      payEl.innerHTML =
        '<p><strong>' + fmt(Math.round(price * 0.9)) + ' no Pix</strong> <span class="tfr-qv__off">(10% OFF)</span></p>' +
        '<p><strong>8x de ' + fmt(Math.round(price / 8)) + ' sem juros</strong> no cartão</p>';
    }

    function message(template, variant) {
      var selections = data.options.map(function (name, i) { return { name: name, value: selected[i] }; });
      var link = helpers.productUrlWithVariant ? helpers.productUrlWithVariant(data.url, variant && variant.id) : data.url;
      if (helpers.buildMessage) return helpers.buildMessage(template, { title: data.title, link: link, selections: selections });
      return data.title + ' – ' + link;
    }

    function update() {
      // Disponibilidade de cada valor, considerando o que já foi escolhido nas outras opções.
      fieldsets.forEach(function (fs) {
        var idx = Number(fs.dataset.tfrQvOption);
        fs.querySelectorAll('.tfr-qv__value').forEach(function (btn) {
          var val = btn.dataset.value;
          var possible = data.variants.some(function (v) {
            return v.available && v.options[idx] === val && v.options.every(function (o, i) { return i === idx || selected[i] === null || selected[i] === o; });
          });
          btn.classList.toggle('is-unavailable', !possible);
          btn.setAttribute('aria-pressed', selected[idx] === val ? 'true' : 'false');
        });
        var label = fs.querySelector('[data-tfr-qv-selected]');
        if (label) label.textContent = selected[idx] || 'Selecione';
      });

      var variant = matching();
      var shown = variant || data.variants.find(function (v) { return v.available; }) || data.variants[0];
      if (priceEl) priceEl.textContent = fmt(shown.price);
      if (compareEl) {
        if (shown.compare > shown.price) { compareEl.hidden = false; compareEl.textContent = fmt(shown.compare); }
        else { compareEl.hidden = true; }
      }
      pay(shown.price);

      var missing = data.options.filter(function (_, i) { return selected[i] === null; });
      var number = String(data.number || '').replace(/\D/g, '');
      if (missing.length) {
        wa.dataset.blocked = 'true';
        waLabel.textContent = 'Comprar pelo WhatsApp';
        hint.textContent = '';
        wa.href = 'https://wa.me/' + number;
        wa.dataset.missing = missing.join(' e ');
        return;
      }
      wa.dataset.blocked = 'false';
      hint.textContent = '';
      if (!variant) {
        wa.dataset.blocked = 'true';
        wa.dataset.missing = '';
        return;
      }
      var available = variant.available;
      var template = available ? (data.templates.buy || DEFAULT_BUY) : (data.templates.unavailable || DEFAULT_UNAVAILABLE);
      waLabel.textContent = available ? 'Comprar pelo WhatsApp' : 'Consultar disponibilidade';
      if (!available) hint.textContent = 'Esta opção está indisponível no momento. Fale com a gente para consultar.';
      wa.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message(template, variant));
    }

    fieldsets.forEach(function (fs) {
      var idx = Number(fs.dataset.tfrQvOption);
      fs.addEventListener('click', function (e) {
        var btn = e.target.closest('.tfr-qv__value');
        if (!btn) return;
        selected[idx] = btn.dataset.value;
        update();
        if (fs.classList.contains('tfr-qv__opt--color')) {
          var v = data.variants.find(function (x) { return x.options[idx] === selected[idx] && x.media; });
          if (v) goToMedia(v.media);
        }
      });
    });

    wa.addEventListener('click', function (e) {
      if (wa.dataset.blocked !== 'true') return;
      e.preventDefault();
      hint.textContent = wa.dataset.missing ? 'Escolha ' + wa.dataset.missing.toLowerCase() + ' para continuar.' : 'Essa combinação não está disponível. Escolha outra opção.';
      var first = Array.from(fieldsets).find(function (fs) { return selected[Number(fs.dataset.tfrQvOption)] === null; });
      if (first) {
        first.classList.remove('is-attention');
        void first.offsetWidth;
        first.classList.add('is-attention');
      }
    });

    update();
  }

  // Abre a prévia ao tocar em "Ver detalhes" (antes do link do card agir).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.tfr-card__more');
    if (!trigger || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var url = productUrlFrom(trigger);
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    open(url);
  }, true);

  // Torna o "Ver detalhes" acessível por teclado.
  function enhance(scope) {
    (scope || document).querySelectorAll('.tfr-card__more:not([data-tfr-qv-ready])').forEach(function (el) {
      el.setAttribute('data-tfr-qv-ready', '');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.removeAttribute('aria-hidden');
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(); });
  else enhance();
  new MutationObserver(function () { enhance(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
